<div class="modal-body" style="height: 100%">
  <div style="height: 100%">
    <div class="col-sm-12 header" style="padding: 0px">
      <h4 class="col-sm-7" style="padding:0px; margin: 0;">
        <span> Compte Collectif par TVA </span>
      </h4>
      <div class="col-sm-5 text-right">
        <button class="btn-close uppercase" (click)="annuler()" id="close2" style="margin-right: 5px">
          Fermer </button>
        <button class="btn-valider btn-facture  uppercase actionPricipal" id="valide2" (click)="save()"
          style="height: 30px; font-size: 10px">
          Valider </button>
      </div>
    </div>
    <div class="col-sm-12 tab compta" style="padding: 5px 0 0; height: calc(100% - 30px);">

      <ngx-datatable style="height: 100%" class="material cubage" [rows]="listeComptesArticleParTVA || []"
        [columnMode]="'force'" [headerHeight]="40" [footerHeight]="0" [rowHeight]="40"
        [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator">
        <ngx-datatable-column name="Code" [width]="25">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Code</span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <label>{{ row.tva.id }}</label>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Taux" [width]="25">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Taux</span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <label>{{ row.tva.taux }}</label>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="compteCollectif">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Compte Collectif</span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <input type="text" class="form-control" [(ngModel)]="row.compteCollectif">
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>

    </div>
  </div>
</div>